import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../Card";
import axios from "axios";
import {Checkbox} from "../../atoms/CheckBox";
import "./index.css";
import { resolveGatewayBackedServiceBaseUrl } from "../../../services/serviceBaseUrl";

const CHAT_SERVICE_URL = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_CHAT_SERVICE_URL);

const DeleteChatPopup = ({
                             chatId,
                             onSuccess,
                             closeModal,
                             selectedChatId,
                             setSelectedChatId,
                             allowDeleteForAll = true,
                         }) => {
    const { t } = useTranslation();
    const [confirmDeleteForAll, setConfirmDeleteForAll] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState(null);

    useEffect(() => {
        if (!allowDeleteForAll && confirmDeleteForAll) {
            setConfirmDeleteForAll(false);
        }
    }, [allowDeleteForAll, confirmDeleteForAll]);

    const handleDelete = async () => {
        setIsDeleting(true);
        setDeleteError(null);
        try {
            await axios.delete(
                `${CHAT_SERVICE_URL}/api/chat/${chatId}?mode=${allowDeleteForAll && confirmDeleteForAll ? "FOR_ALL" : "FOR_ME"}`,
                { withCredentials: true }
            );

            if (selectedChatId === chatId) {
                setSelectedChatId(null);
            }

            onSuccess(chatId); // remove chat from list in parent
            closeModal();
        } catch (err) {
            console.error("❌ Error deleting chat:", err);
            setDeleteError(t("chat.deleteChat.error"));
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Card
            id="deleteChatPopup"
            title={
                <>
                    <span className="delete-chat-popup__eyebrow">{t("chat.deleteChat.eyebrow")}</span>
                    <span className="delete-chat-popup__title">{t("chat.deleteChat.title")}</span>
                </>
            }
            body={
                <>
                    <p className="delete-chat-popup__prompt">{t("chat.deleteChat.prompt")}</p>
                    {allowDeleteForAll && (
                        <Checkbox
                            isChecked={confirmDeleteForAll}
                            onChange={(e) => setConfirmDeleteForAll(e.target.checked)}
                            label={t("chat.deleteChat.deleteForAll")}
                        />
                    )}
                    {deleteError && (
                        <p className="delete-chat-popup__error" role="alert">
                            {deleteError}
                        </p>
                    )}
                </>
            }
            footer={
                <div className="delete-chat-popup__actions">
                    <button
                        type="button"
                        className="delete-chat-popup__cancel"
                        onClick={closeModal}
                        disabled={isDeleting}
                    >
                        {t("chat.deleteChat.cancel")}
                    </button>
                    <button
                        type="button"
                        className="delete-chat-popup__confirm"
                        onClick={handleDelete}
                        disabled={isDeleting}
                    >
                        {isDeleting ? t("chat.deleteChat.deleting") : t("chat.deleteChat.confirm")}
                    </button>
                </div>
            }
        />
    );
};

export default DeleteChatPopup;
